import styled from 'styled-components';

export const Container = styled.div`
  padding-left: 10px;
  border-radius: 2px;
  background-color: ${(props) => props.theme.darkGrey};
  display: flex;
  align-items: center;
`;

export const CloseIcon = styled.button`
  display: flex;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;
